import React from 'react'
import PropTypes from 'prop-types'
import QuantityField from './QuantityField'

class QuantityProduct extends React.Component {
  static MINIMUM_QUANTITY = 1

  static propTypes = {
    product: PropTypes.object.isRequired,
    bundleProduct: PropTypes.object,
    onChange: PropTypes.func,
    style: PropTypes.object,
  }

  onChangeQuantity = (value) => {
    this.props.onChange({quantity: value})
  }

  render() {
    const {MINIMUM_QUANTITY} = this.constructor
    const bundleQuantity = this.props.bundleProduct ? this.props.bundleProduct.quantity : null
    const minQuantity = bundleQuantity || MINIMUM_QUANTITY

    return (
      <>
        <div>
          Antall bilder {minQuantity !== 0 ? `(min. ${minQuantity})` : ''}
        </div>
        <QuantityField
          minValue={minQuantity}
          value={this.props.product.quantity}
          onChange={this.onChangeQuantity}
        />
      </>
    )
  }
}

export default QuantityProduct
